export const loadFonts = () => {
  if ('fonts' in document) {
    // 使用Font Loading API优化加载
    Promise.all([
      document.fonts.load('1em Manrope'),
      document.fonts.load('700 1em Manrope')
    ]).then(() => {
      document.documentElement.classList.add('fonts-loaded');
    });
  } else {
    // 回退方案
    const style = document.createElement('style');
    style.textContent = `
      @font-face {
        font-family: 'Manrope';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/Manrope-Regular.woff2') format('woff2');
      }
      @font-face {
        font-family: 'Manrope';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/Manrope-Bold.woff2') format('woff2');
      }
    `;
    document.head.appendChild(style);
  }
};

export const preloadFonts = () => {
  const preloadLinks = [
    { href: '/fonts/Manrope-Regular.woff2', as: 'font', type: 'font/woff2', crossorigin: true },
    { href: '/fonts/Manrope-Bold.woff2', as: 'font', type: 'font/woff2', crossorigin: true }
  ];

  preloadLinks.forEach(link => {
    const el = document.createElement('link');
    el.rel = 'preload';
    el.as = link.as;
    el.href = link.href;
    el.type = link.type;
    if (link.crossorigin) el.setAttribute('crossorigin', '');
    document.head.appendChild(el);
  });
};